
export interface ChangeLogState {
    changeLog: Array<any>;
    downloadChangeLogCsvResponse: any;
}

export const initialState: ChangeLogState = {
    changeLog: null,
    downloadChangeLogCsvResponse: null
}
